/**
 * Frøya qty-tier tags for giftAddToCart.
 *
 * giftAddToCart rebuilds line properties and drops hidden _froya_* inputs.
 * This file does not edit the gift engine. It wraps giftAddToCart and, only
 * when qty-tier tags or cart-drawer pairing tags exist, merges FROYA_KEYS onto
 * the matching /cart/add.js trigger line. Empty extra = original add, no fetch
 * wrap work.
 *
 * Pairing tags come from the PAIR WITH cards in
 * snippets/cart-drawer-recommendations.liquid (_froya_source=cart_pair_with,
 * _froya_pair_slot, _froya_pair_anchor, _froya_pair_list) and travel with or
 * without a promo.
 *
 * Never copies other form properties. Never changes id, quantity, selling_plan.
 */
(function () {
  'use strict';

  if (window.__FROYA_GIFT_QTY_BRIDGE__) return;
  window.__FROYA_GIFT_QTY_BRIDGE__ = true;

  var PROMO_ID_KEY = '_froya_promo_id';
  var PURCHASE_TYPE_KEY = '_froya_purchase_type';
  var QTY_TIER_KEY = '_froya_qty_tier';
  var SOURCE_KEY = '_froya_source';
  var FROYA_KEYS = [
    PROMO_ID_KEY,
    PURCHASE_TYPE_KEY,
    QTY_TIER_KEY,
    SOURCE_KEY,
    '_froya_pair_slot',
    '_froya_pair_anchor',
    '_froya_pair_list',
  ];

  var stack = [];
  var nativeFetch = null;
  var fetchHooked = false;

  function toVariantGid(id) {
    if (id == null || id === '') return '';
    var raw = String(id);
    if (raw.indexOf('gid://') === 0) return raw;
    return 'gid://shopify/ProductVariant/' + raw;
  }

  function findQtyTierPromo(config, variantGid, templateName) {
    if (!config || !variantGid) return null;
    var bundles = Array.isArray(config.bundles) ? config.bundles : [];
    var siteWide = null;
    for (var i = 0; i < bundles.length; i++) {
      var promo = bundles[i];
      if (!promo || promo.promoType !== 'quantity_tier') continue;
      if (promo.active === false) continue;
      var ids = Array.isArray(promo.variantIds) ? promo.variantIds : [];
      if (ids.indexOf(variantGid) === -1) continue;
      var promoTemplate = typeof promo.template === 'string' ? promo.template.trim() : '';
      if (promoTemplate && promoTemplate !== (templateName || '')) continue;
      if (promoTemplate) return promo;
      if (!siteWide) siteWide = promo;
    }
    return siteWide;
  }

  function pickFroyaFromFormData(formData) {
    var extra = {};
    for (var i = 0; i < FROYA_KEYS.length; i++) {
      var key = FROYA_KEYS[i];
      var value = formData.get('properties[' + key + ']');
      if (value) extra[key] = String(value);
    }
    return extra;
  }

  function collectFroyaProperties(form) {
    var extra = {};
    if (!form) return extra;

    var formData = new FormData(form);
    extra = pickFroyaFromFormData(formData);
    if (extra[PROMO_ID_KEY]) return extra;

    var root =
      form.closest('[data-use-variant-quantities]') ||
      form.closest('c-subscription') ||
      form.closest('.c-product-form');
    if (root && root.getAttribute('data-use-variant-quantities') === 'true') {
      return extra;
    }

    var script =
      (root && root.querySelector('[data-froya-qty-tier-config]')) ||
      form.querySelector('[data-froya-qty-tier-config]') ||
      document.querySelector('[data-froya-qty-tier-config]');
    if (!script) return extra;

    var config;
    try {
      config = JSON.parse(script.textContent || '{}');
    } catch (e) {
      return extra;
    }

    var variantId = formData.get('id');
    if (!variantId) {
      var idInput =
        form.querySelector('input.js-variant-quantity-selector:checked') ||
        form.querySelector('input[name="id"]:checked') ||
        form.querySelector('input[name="id"]');
      variantId = idInput && idInput.value;
    }

    var promo = findQtyTierPromo(
      config,
      toVariantGid(variantId),
      script.getAttribute('data-froya-template') || '',
    );
    if (!promo) return extra;

    var purchaseType =
      formData.get('purchase_type') === 'subscription' || formData.get('selling_plan')
        ? 'subscription'
        : 'one_time';
    var qtyRadio = form.querySelector('input[name="quantity"]:checked');
    var qtyRaw = (qtyRadio && qtyRadio.value) || formData.get('quantity') || '1';
    var qty = parseInt(String(qtyRaw), 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    extra[PROMO_ID_KEY] = promo.id;
    extra[PURCHASE_TYPE_KEY] = purchaseType;
    extra[QTY_TIER_KEY] = String(qty);
    return extra;
  }

  function hasFroyaTags(extra) {
    return !!(extra && (extra[PROMO_ID_KEY] || extra[SOURCE_KEY]));
  }

  function idsEqual(a, b) {
    if (a == null || b == null || a === '') return false;
    return String(a) === String(b);
  }

  function isGiftLineProps(props) {
    if (!props) return false;
    var v = props._autoGift;
    return v === true || v === 'true' || v === 'True';
  }

  function isCartAddPost(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    var path = '';
    try {
      path = new URL(String(url || ''), window.location.href).pathname;
    } catch (e) {
      path = String(url || '').split('?')[0];
    }
    return /\/cart\/add(\.js)?$/.test(path);
  }

  function stampPayload(payload, extra, variantId) {
    if (!payload || !hasFroyaTags(extra) || !variantId) return payload;

    if (Array.isArray(payload.items)) {
      for (var i = 0; i < payload.items.length; i++) {
        var item = payload.items[i];
        if (!item || isGiftLineProps(item.properties)) continue;
        if (!idsEqual(item.id, variantId)) continue;
        item.properties = Object.assign({}, item.properties || {}, extra);
      }
      return payload;
    }

    if (idsEqual(payload.id, variantId) && !isGiftLineProps(payload.properties)) {
      payload.properties = Object.assign({}, payload.properties || {}, extra);
    }
    return payload;
  }

  function currentContext() {
    return stack.length ? stack[stack.length - 1] : null;
  }

  function installFetchHook() {
    if (fetchHooked) return;
    fetchHooked = true;
    nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var ctx = currentContext();
      if (ctx && hasFroyaTags(ctx.extra) && nativeFetch) {
        try {
          var url = typeof input === 'string' ? input : input && input.url;
          var method = (init && init.method) || (input && input.method) || 'GET';
          var body = init && typeof init.body === 'string' ? init.body : null;
          if (body && isCartAddPost(url, method)) {
            var parsed = JSON.parse(body);
            stampPayload(parsed, ctx.extra, ctx.variantId);
            init = Object.assign({}, init, { body: JSON.stringify(parsed) });
          }
        } catch (e) {
          /* keep original body */
        }
      }
      return nativeFetch.call(this, input, init);
    };
  }

  function readVariantId(form, extraFormData) {
    var formData = extraFormData || (form ? new FormData(form) : null);
    if (!formData) return '';
    return String(formData.get('id') || '');
  }

  function wrapInstance() {
    try {
      var inst = window.giftManager && window.giftManager.instance && window.giftManager.instance();
      if (!inst || inst.__froyaQtyPatched || typeof inst.addProductWithGifts !== 'function') {
        return;
      }
      var original = inst.addProductWithGifts.bind(inst);
      inst.addProductWithGifts = function (productData, giftVariantIds) {
        try {
          var ctx = currentContext();
          if (ctx && hasFroyaTags(ctx.extra) && productData && idsEqual(productData.id, ctx.variantId)) {
            productData = Object.assign({}, productData, {
              properties: Object.assign({}, productData.properties || {}, ctx.extra),
            });
          }
        } catch (e) {
          /* use original productData */
        }
        return original(productData, giftVariantIds);
      };
      inst.__froyaQtyPatched = true;
    } catch (e) {
      /* gift manager not ready */
    }
  }

  function wrapGiftAddToCart() {
    var original = window.giftAddToCart;
    if (typeof original !== 'function' || original.__froyaQtyPatched) {
      wrapInstance();
      return typeof original === 'function' && original.__froyaQtyPatched;
    }

    installFetchHook();

    function patched(button, options) {
      var extra = {};
      var variantId = '';
      try {
        var form = button && button.closest ? button.closest('form') : null;
        extra = collectFroyaProperties(form);
        variantId = readVariantId(form);
      } catch (e) {
        extra = {};
      }

      var ctx = { extra: extra, variantId: variantId };
      stack.push(ctx);
      wrapInstance();

      var restoreTimer = setTimeout(function () {
        var idx = stack.indexOf(ctx);
        if (idx !== -1) stack.splice(idx, 1);
      }, 8000);

      function restore() {
        clearTimeout(restoreTimer);
        var idx = stack.indexOf(ctx);
        if (idx !== -1) stack.splice(idx, 1);
      }

      try {
        var result = original.call(this, button, options);
        if (result && typeof result.then === 'function') {
          return result.then(
            function (value) {
              restore();
              return value;
            },
            function (error) {
              restore();
              throw error;
            },
          );
        }
        restore();
        return result;
      } catch (error) {
        restore();
        throw error;
      }
    }

    patched.__froyaQtyPatched = true;
    window.giftAddToCart = patched;
    wrapInstance();
    return true;
  }

  var tries = 0;
  function boot() {
    wrapGiftAddToCart();
    wrapInstance();
    if (window.giftAddToCart && window.giftAddToCart.__froyaQtyPatched) {
      if (window.giftManager && window.giftManager.instance && window.giftManager.instance()) {
        wrapInstance();
        return;
      }
    }
    tries += 1;
    if (tries > 60) return;
    setTimeout(boot, 250);
  }

  boot();
  document.addEventListener('gift-rules-ready', boot);
})();
